module.exports = __webpack_public_path__ + "images/icons_v2/battery-f0ff7b79.svg";